const COMPONENT_CLASS = "xyl-progress";
const ACTIVE_CLASS = "active";
const INFO_CLASS = "xyl-progress-info";
const BAR_CLASS = "xyl-progress-bar";

function init() {}

const settings = {
	COMPONENT_CLASS,
	ACTIVE_CLASS,
	INFO_CLASS,
	BAR_CLASS,
};

export { init, settings };
